// Teller voor het trustblok op de homepage: het aantal mensen dat via een
// organisatie terecht kan bij een vertrouwenspersoon van PuntUit.
//
// De waarde is een functie van de tijd, niet van het bezoek: iedereen die de
// site op hetzelfde moment bekijkt ziet hetzelfde getal, en het loopt vanzelf
// langzaam op zonder dat er iets aangepast hoeft te worden.
//
// Wil je het getal bijstellen (bijvoorbeeld na een nieuwe telling)? Zet
// BASE_COUNT op het nieuwe aantal en BASE_DATE op de datum van die telling.

/** Gemeten aantal mensen op BASE_DATE. */
export const BASE_COUNT = 45_595;

/** Peildatum van BASE_COUNT (UTC-middernacht). */
export const BASE_DATE = Date.UTC(2026, 8, 3); // 3 september 2026

/**
 * Groei per dag. 15 per dag ≈ 450 per maand ≈ 5.500 per jaar, ongeveer het
 * tempo waarin er organisaties bijkomen. Bewust laag gehouden: de teller moet
 * geloofwaardig blijven, niet spectaculair.
 */
export const GROWTH_PER_DAY = 15;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Het aantal mensen op een gegeven moment (standaard: nu). */
export function getTrustCount(now: number = Date.now()): number {
  const days = (now - BASE_DATE) / MS_PER_DAY;
  if (days <= 0) return BASE_COUNT;
  return BASE_COUNT + Math.floor(days * GROWTH_PER_DAY);
}

/** Gemeten aantal organisaties op BASE_DATE. */
export const BASE_ORG_COUNT = 500;

/** Gemiddeld aantal mensen per organisatie, afgeleid uit de peiling (~91). */
export const PEOPLE_PER_ORG = Math.round(BASE_COUNT / BASE_ORG_COUNT);

/**
 * Het bedrijvenaantal loopt in stappen van 10 op. Een teller die van 500 naar
 * 501 springt oogt raar bij organisaties; met stappen van 10 komt er ongeveer
 * elke maand een stap bij, in hetzelfde tempo als de mensenteller.
 */
export const ORG_STEP = 10;

/** Het aantal organisaties op een gegeven moment (standaard: nu). */
export function getOrgCount(now: number = Date.now()): number {
  const grown = BASE_ORG_COUNT + (getTrustCount(now) - BASE_COUNT) / PEOPLE_PER_ORG;
  return Math.floor(grown / ORG_STEP) * ORG_STEP;
}

/** 45595 -> "45.595" (Nederlandse duizendtalscheiding, zonder Intl). */
export function formatCount(value: number): string {
  return Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
